export function upc(state, payload) {
    return {...state, upc: payload};
}

export function power_upc(state, payload) {
    return {...state, power_upc: payload, upc: payload};
}

export function packages(state, pkgs) {
    const standard_packages_min_coins = 50;
    const power_packages_min_coins = 2000;

    const kcpackages = pkgs.reduce((kcpackages, pkg) => {
        let kcs = pkg.free_kcs + pkg.paid_kcs;
        let percent = 0;

        if (pkg.label && pkg.label.match(/[0-9]+\%/)) {
            percent = pkg.label.match(/[0-9]+\%/)[0];
        }

        pkg.percent = percent;

        if (kcs >= power_packages_min_coins) {
            kcpackages.power.push(pkg);
        } else if (kcs > standard_packages_min_coins) {
            kcpackages.standard.push(pkg);
        }

        return kcpackages;
    }, {power: [], standard: []});

    return {
        ...state,
        packages: {
            power: kcpackages.power,
            standard: kcpackages.standard.reverse(),
        },
    };
}



// WEBPACK FOOTER //
// ./app/reducers/karmacoin-store.js